import React, { useState, useRef, useEffect, useContext } from "react";
import { Col, InputGroup, Form } from "react-bootstrap";
import {REDUCER_ACTION_FILTER, SecurityContext, SecurityDispatchContext} from "../../../../../context/security-context";
import styles from "../tab-orders/tab-orders.module.scss";

const FilterOrder = ({ headers, setPage}) => {
  const onFirstLoad = useRef(true);
  const { ordersState } = useContext(SecurityContext);
  const { ordersDispatch } = useContext(SecurityDispatchContext);
  const [ filterState, setFilterState ] = useState({
    filter: '',
    filterBy: 'primaryApplicant',
    filterByStatus: ''
  });

  const onFilterChange = e => {
    setFilterState({
      ...filterState,
      filter: e.target.value
    })
  }

  const onFilterByChange = e => {
    setFilterState({
      ...filterState,
      filterBy: e.target.value
    })
  }

  const onFilterByStatusChange = e => {
    setFilterState({
      ...filterState,
      filterByStatus: e.target.value
    })
  }

  useEffect(()=>{
    if (onFirstLoad.current)
      onFirstLoad.current = false;
    else {
      ordersDispatch({
        type: REDUCER_ACTION_FILTER,
        previous: ordersState,
        data: filterState
      });
      setPage(1);
    }
  }, [filterState]);

  return (
    <>
      <Col className={styles['filter-actions']} xs={{ span: 12, order: 1 }} lg={{ span: 6, order: 3}}>
        <InputGroup size="sm">
          <Form.Control onChange={onFilterChange} type="text" placeholder="Search" />
          <InputGroup.Append >
            <Form.Control onChange={onFilterByChange} size="sm" as="select" defaultValue="applicantName">
              {headers.map((h,i) => h.filter && <option key={i} value={h.key}>{h.value}</option>)}
            </Form.Control>
          </InputGroup.Append>
        </InputGroup>
      </Col>
      <Col className={styles['filter-actions']} xs={{ span: 12, order: 2 }} lg={{ span: 2, order: 4}}>
        <Form.Control onChange={onFilterByStatusChange} size="sm" as="select" >
          <option value="">All</option>
          <option value="0">Pending</option>
          <option value="1">Accepted</option>
          <option value="2">Rejected</option>
        </Form.Control>
      </Col>
    </>
  );
}

export default FilterOrder;
